import React from 'react'
import { Button } from '@material-ui/core';
import useStyles from './style';
import { chatRedirect } from '../../utils';

const FooterViewer = (props) => {
    const { saveData, isUpdated, listPages } = props;
    const { chartData } = props.data || {};
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Button variant="contained" className={classes.cancelButton} onClick={() => { chatRedirect(props.history, props.match.params.appid, listPages) }}>Cancel</Button>
            <Button variant="contained" className={classes.saveButton} onClick={() => { saveData() }}>{isUpdated ? 'Update' : 'Save'}</Button>
        </div>
    )
}

export default FooterViewer